<script setup lang="ts">
import { inject } from "vue";
import LoginForm from "@/components/LoginForm.vue";
import type { RetailInstanceTypeService } from "@/services/RetailInstanceTypeService";
import { retailInstanceTypeSymbol } from "@/models/Symbols";

const instanceTypeSvc = inject(retailInstanceTypeSymbol) as RetailInstanceTypeService;
</script>

<template>
    <div class="login-container" :class="instanceTypeSvc.isCorporate() ? 'business-background' : 'personal-background'">
        <div class="overlay"></div>

        <div class="d-flex justify-center align-center">
            <div>
                <LoginForm></LoginForm>
            </div>
        </div>
    </div>

</template>

<style scoped>
.login-container {
    display: grid;
    width: 100%;
    height: 89vh;
    padding-top: 16px;
    position: relative;
}

.upgrade-alert-text {
    font-size: 1rem;
}

.upgrade-alert-text a {
    color: white;
    font-weight: 500;
    cursor: pointer;
    margin-left: 12px;
}

.overlay {
    width: 100%;
    height: 100%;
    background-color: rgba(50,50,50,0.4);
    position: absolute;
}

.personal-background {
    background-image: url('https://cdn.mytrainticket.co.uk/wp-content/uploads/railway-scaled-1920.jpg');
    background-size: cover;
    background-position: center;
}

.business-background {
    background-image: url('https://cdn.mytrainticket.co.uk/wp-content/uploads/business-scaled-1920.jpg');
    background-size: cover;
    background-position: center;
}
</style>
